"use strict";
/**
 *
 * Portal
 *
 * Implementation from:
 * https://github.com/mui-org/material-ui/blob/f55f3a4f808d1756d11d056195978affe4f65d5b/packages/material-ui/src/Portal/Portal.js
 *
 */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const hooks_1 = require("../hooks");
function getContainer(container) {
    container = typeof container === 'function' ? container() : container;
    // #StrictMode ready
    // eslint-disable-next-line react/no-find-dom-node
    return react_dom_1.default.findDOMNode(container);
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */
exports.Portal = react_1.default.forwardRef(function Portal(props, ref) {
    const { children, container, disablePortal = false, onRendered } = props;
    const [mountNode, setMountNode] = react_1.useState(null);
    const childRef = react_1.useRef(null);
    // as any because .ref does indeed exist
    const handleRef = hooks_1.useForkRef(children.ref, childRef);
    react_1.useLayoutEffect(() => {
        if (!disablePortal) {
            setMountNode(container ? getContainer(container) : document.body);
        }
    }, [container, disablePortal]);
    react_1.useImperativeHandle(ref, () => mountNode || childRef.current, [mountNode]);
    react_1.useLayoutEffect(() => {
        if (onRendered && mountNode) {
            onRendered();
        }
    }, [mountNode, onRendered]);
    if (disablePortal) {
        react_1.default.Children.only(children);
        return react_1.default.cloneElement(children, {
            ref: handleRef,
        });
    }
    return mountNode ? react_dom_1.default.createPortal(children, mountNode) : mountNode;
});
if (process.env.NODE_ENV !== 'production') {
    exports.Portal.displayName = 'Portal';
}
